var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSucessOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.668,
    height: 26.584,
    viewBox: "0 0 39.668 26.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkmark-done-outline",
    d: "M82.018,128,63.7,148.934l-7.85-7.85m0,7.85L48,141.084M74.167,128,63.046,140.757",
    transform: "translate(-45.172 -125.178)",
    fill: "none",
    stroke: "#0eb908",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessOutlineIcon);
export default __webpack_public_path__ + "static/media/sucess-outline-icon.e529544d51a980f499355bac18ac18e3.svg";
export { ForwardRef as ReactComponent };